<template>
  <router-view/>
</template>

<script>
    import RouteEntryMixin from '@com/mixins/route-entry'
    export default {
      name: 'TopupBalance',
      mixins: [RouteEntryMixin],
      data: _ => ({
        routes: [
            { path: '/topup-balance/make', label: 'TopupBalance' }
        ]
      })
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/vue/app/topupBalance/TopupBalance.Entry.vue